export const STORAGE_SETTING = {
    rcpUdata: 'rcpUdata',
    Lang: 'lang',
    ac: 'ac',
    bpTkn: 'bpToken',
    Stores: {
        appStore: 'app-store',
    },
};
